module.exports = __webpack_public_path__ + "static/media/Jackie Bell Vanity (6).eb4a7817.JPG";